module.exports = __webpack_public_path__ + "2dba6e8d68b9d5c358d81f69ea6dfffb.pdf";